<div class="container" id="print-section1">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th colspan="7" style="font-size: 14px; text-align: center;">विवेक साप्ताहिक</th>
            </tr>
            <tr>
                <th colspan="1" style="font-size: 14px;">विस्तृत वर्गणीदार तपशील</th>
                <th colspan="4" style="font-size: 14px;">{{data.country}} | {{ getStateName(data.state_name) }} | {{data.district_name}} | {{data.taluka_name}} | {{data.prant_name}} | {{data.subno}}
                 | {{data.crdt_voucher_no}} | {{data.rcpt_no}} | {{data.delivery_mode}} | {{data.office_rep_name}} | {{data.rep_name}} | {{data.subtype}} | {{data.name}}
                </th>
                <th colspan="2" style="text-align: center; font-size: 14px;">दिनांक : {{ data.start_date | date: 'dd-MM-yyyy'}} ते {{ data.end_date | date: 'dd-MM-yyyy'}} </th> 
            </tr>
            <tr>
                <td style="text-align: center; font-size: 14px; font-weight: bold;">अ.क्रमांक</td>
                <th style="font-size: 14px;">वर्गणीदार क्रमांक</th>
                <th style="font-size: 14px;">वर्गणीदार नाव</th>
                <th style="font-size: 14px;">पत्ता</th>
                <th style="font-size: 14px;">वर्गणीदार प्रकार</th>
                <th style="font-size: 14px;">वर्गणी कालावधी</th>
                <th style="font-size: 14px;">संपर्क</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let data1 of subscriberdetailsbrief; let i = index">
                <td style="text-align: right;">{{i + 1}}</td>
                <td style="text-align: right;">{{data1.subscription_type}}{{data1.month}}/{{data1.subno}}</td>
                <td>{{data1.title}}.{{data1.name}}</td>
                <td>{{data1.address}} {{data1.taluka}},{{data1.district}}{{data1.state}} {{data1.country}},{{data1.pincode}} </td>
                <td style="text-align: right;">{{data1.subscription_type}}</td>
                <td>{{data1.sub_perid_from_date | date:'dd/MM/yyyy'}}-{{data1.sub_perid_to_date | date:'dd/MM/yyyy'}}</td>
                <td>{{data1.mobileNumber}}</td>
                
            </tr>

        </tbody>
    </table>
    <div style="margin-left: 50%;  margin-bottom: 2%">

      <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
      (click)="exportExcel('Subscribers Details Brief Report')" mat-raised-button color="primary">
      Export
  </button>

        <button class="noPrint"
        style="margin-top: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
  </div>
</div>
